import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { StyledBadgeSpan } from "./styles";
export var ColorBadge = forwardRef(function ColorBadge(_a, ref) {
    var _b = _a.customColor, customColor = _b === void 0 ? "primary" : _b, children = _a.children, props = __rest(_a, ["customColor", "children"]);
    return (_jsx(StyledBadgeSpan, __assign({ "$customColor": customColor, ref: ref }, props, { children: children })));
});
//# sourceMappingURL=index.js.map